export const TOKEN_KEY = 'thelandapp.user.token';
